<template>
    <div>
        <v-dialog 
            v-model="secondaryUserDialog" 
            transition="dialog-top-transition"
            persistent
            max-width="45%">
            <v-card>
                <v-card-title class="primary darken-2">
                    <div class="white--text">Edit User</div>
                    <v-spacer></v-spacer>
					<v-btn 
						icon
						class="ml-3 white--text"
						@click="closeSecondary()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
                </v-card-title>
                <v-card-text class="pt-2">
                    <!-- :parentUserId="projectDetails.users.user_id" -->
                    <SecondaryUser 
                        :project="projectDetails"
                        :thisUser="thisUser"
                        :secondaryUserDialog="secondaryUserDialog"
                        :resetCreateNewUser="resetCreateNewUser"
                        @refreshUsers="emitUserRefresh"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>

        <div v-if="!projectOwners.length && !projectSecondaryUsers.length && !projectPartners.length" class="ma-6">
            No additional users to show
        </div>

        <v-card v-if="projectDetails.users.length" class="pl-4 pr-0" elevation="0">
            <div class="pr-4 pl-0 pt-0">
                <div v-if="projectOwners.length >= 2" class="mt-3 subtitle-1 d-block">Clients</div>
                <v-data-table
                    v-if="projectOwners.length"
                    :headers="owner_header"
                    :items="projectOwners"
                    hide-default-footer
                    class="mb-12">
                    
                    <template v-slot:header="{ headers }">
                        <thead>
                            <tr>
                                <td v-for="column in headers" :key="column.value">
                                    {{column.text}}
                                </td>
                            </tr>
                        </thead>
                    </template>

                    <template v-slot:body="{ items }">
                        <tbody name="list" is="transition-group">
                            <tr v-for="item in items" :key="item.user_id" class="item-row avenir_book">
                                <td class="text-start">{{ item.first_name }} {{ item.last_name }}</td>
                                <td class="text-start">{{ item.phone }}</td>
                                <td class="text-start">{{ item.user_email }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            
                <div v-if="projectSecondaryUsers.length" class="mt-3 subtitle-1 d-block">Secondary Users</div>
                <v-data-table
                    v-if="projectSecondaryUsers.length"
                    :headers="not_owners ? no_action_headers : users_header"
                    :items="projectSecondaryUsers"
                    hide-default-footer
                    class="mb-12">
                    
                    <template v-slot:header="{ headers }">
                        <thead>
                            <tr>
                                <td v-for="column in headers" :key="column.value">
                                    {{column.text}}
                                </td>
                            </tr>
                        </thead>
                    </template>

                    <template v-slot:body="{ items }">
                        <tbody name="list" is="transition-group">
                            <tr v-for="item in items" :key="item.id" class="item-row avenir_book">
                                <td class="text-start">{{ item.first_name }} {{ item.last_name }}</td>
                                <td class="text-start text-capitalize">
                                    <v-icon  
                                        :class="item.read ? 'secondary--text text-lighten-1' : 'error--text text--darken-2'">
                                        {{ item.read ? 'mdi-checkbox-marked' : 'mdi-close-box' }}
                                    </v-icon>
                                </td>
                                <td class="text-start text-capitalize">
                                    <v-icon  
                                        :class="item.write ? 'secondary--text text-lighten-1' : 'error--text text--darken-2'">
                                        {{ item.write ? 'mdi-checkbox-marked' : 'mdi-close-box' }}
                                    </v-icon>
                                </td>
                                <td class="text-start text-capitalize">
                                    <v-icon  
                                        :class="item.deliverables ? 'secondary--text text-lighten-1' : 'error--text text--darken-2'">
                                        {{ item.deliverables ? 'mdi-checkbox-marked' : 'mdi-close-box' }}
                                    </v-icon>
                                </td>
                                <td class="text-start">
                                    <div v-if="formatDate(item.expires, 'mmm. d, yyyy')">
                                        {{ formatDate(item.expires, 'mmm. d, yyyy') }}
                                    </div>
                                    <div v-else>
                                        <v-tooltip right>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    v-bind="attrs"
                                                    v-on="on">
                                                    mdi-infinity
                                                </v-icon>
                                            </template>
                                            <span class="no_expiration">No Expiration</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                                <td v-if="!not_owners" class="text-start" width="">
                                    <v-icon
                                        small
                                        class="mr-2"
                                        @click="editUser(item)">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon
                                        small
                                        @click="deleteUser(item)">
                                        mdi-delete
                                    </v-icon>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
        
                <div v-if="projectPartners.length" class="mt-3 subtitle-1 d-block">Partner Firm</div>
                <v-data-table
                    v-if="projectPartners.length"
                    :headers="partner_header"
                    :items="projectPartners"
                    hide-default-footer
                    class="mb-12">
                    
                    <template v-slot:header="{ headers }">
                        <thead>
                            <tr>
                                <td v-for="column in headers" :key="column.value">
                                    {{column.text}}
                                </td>
                            </tr>
                        </thead>
                    </template>

                    <template v-slot:body="{ items }">
                        <tbody name="list" is="transition-group">
                            <tr v-for="item in items" :key="item.user_id" class="item-row avenir_book">
                                <td class="text-start">{{ item.first_name }} {{ item.last_name }}</td>
                                <td class="text-start">{{ item.phone }}</td>
                                <td class="text-start">{{ item.user_email }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </div>
        </v-card>
    </div>
</template>


<script>  
    import axios from "axios";
    import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';
    
    import dateFormat, { masks } from "dateformat";
    import SecondaryUser from './SecondaryUser.vue';

    export default {
        name: 'ProjectUsers',

        components: {
        	SecondaryUser
		},

        props: {
            projectDetails: Object,
            authUser: Object,
            refreshUsers: Function
        },
        
        computed: {
            projectOwners () {
                return this.projectDetails.users.filter( user => user.user_type == 'owner' )
            },
            projectSecondaryUsers () {
                return this.projectDetails.users.filter( user => user.user_type == 'secondary' )
            },
            projectPartners () {
                return this.projectDetails.users.filter( user => user.user_type == 'partner' )
            },
            not_owners () {
                return this.projectSecondaryUsers.find( user => user.user_id == this.authUser.id ) || this.projectPartners.find( user => user.user_id == this.authUser.id ) ? true : false
            }
        },

        data () {
            return {
                owner_header: [
                    {   text: 'Full Name',  value: 'first_name', align: 'start', width:'',   sortable: true },
                    {   text: 'Phone',      value: 'phone',      align: 'left',  width:'',   sortable: true },
                    {   text: 'Email',      value: 'user_email', align: 'left',  width:'',   sortable: true },
                ],
                users_header: [
                    {   text: 'Full Name',                  value: 'full_name',     align: 'start', width:'22%', sortable: true  },
                    {   text: 'Can Read Data',              value: 'read',          align: 'left',  width:'',    sortable: true  },
                    {   text: 'Can Change Data',            value: 'write',         align: 'left',  width:'',    sortable: true  },
                    {   text: 'Can Download Deliverables',  value: 'deliverables',  align: 'left',  width:'',    sortable: true  },
                    {   text: 'Expires',                    value: 'expires',       align: 'left',  width:'14%', sortable: true  },
                    {   text: 'Actions',                    value: 'actions',       align: 'left',  width: '8%', sortable: false },
                ],
                no_action_headers: [
                    {   text: 'Full Name',                  value: 'full_name',     align: 'start', width:'22%', sortable: true  },
                    {   text: 'Can Read Data',              value: 'read',          align: 'left',  width:'',    sortable: true  },
                    {   text: 'Can Change Data',            value: 'write',         align: 'left',  width:'',    sortable: true  },
                    {   text: 'Can Download Deliverables',  value: 'deliverables',  align: 'left',  width:'',    sortable: true  },
                    {   text: 'Expires',                    value: 'expires',       align: 'left',  width:'14%', sortable: true  },
                ],
                partner_header: [
                    {   text: 'Full Name',  value: 'first_name', align: 'start', width:'',   sortable: true },
                    {   text: 'Phone',      value: 'phone',      align: 'left',  width:'',   sortable: true },
                    {   text: 'Email',      value: 'user_email', align: 'left',  width:'',   sortable: true },
                ],
                resetCreateNewUser: false,
                secondaryUserDialog: false,

				parentUserId: String,
				secondaryProject: Object,
				show_addedUsers: false,
				show_addUserFeedback: false,
				added_user_feedback: '',

				thisUser: {
					user_id: null,
                    newuser_firstname: '',
                    newuser_lastname: '', 
                    newuser_email: '',
                    user_permissions: ['r','w'],
                    never_expires: true,
                    expiration_date: ''
                },
				resetCreateNewUser: false
            }
        },

        mounted () {
            // console.log('mounted', this.projectDetails)
        },
        
        methods: {
            
            closeSecondary: function () {
				this.resetCreateNewUser = true
                this.secondaryUserDialog = false
            },
            
            editUser: function ( user ) {
                // console.log(user)                
                let user_perms = []
                if ( user.read ) user_perms.push('r')
                if ( user.write ) user_perms.push('w')
                if ( user.deliverables ) user_perms.push('x')
                
                this.thisUser = {
                    id: user.id,
                    user_id: user.user_id,
                    parent_user_id: user.parent_user_id,
                    project_id: user.project_id,
                    newuser_firstname: user.first_name,
                    newuser_lastname: user.last_name, 
                    newuser_email: user.user_email,
                    user_permissions: user_perms,
                    never_expires: user.expires == 0 ? true : false,
                    expiration_date: user.expires != 0 ? this.formatDate(user.expires, 'yyyy-mm-dd') : '',
                    newuser_type: 'secondary'
                }

                this.secondaryUserDialog = true
			},

            emitUserRefresh: function () {
                this.secondaryUserDialog = false
                this.resetCreateNewUser = true
                this.$emit('refreshUsers', this.projectDetails.project_id, `${this.thisUser.newuser_firstname} was updated successfully!`)
            },

            deleteUser: async function (user) {
                try {
                    // console.log(user)
                    const confirm_rs = confirm('Are you sure you want to delete this user from this project?');

                    if ( confirm_rs ) { 
                        const delete_secondary_user = await axios.put(`${appUrls.api}/api/delete_project_user`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            data: {
                                user: user
                            }
                        })

                        if ( delete_secondary_user.data.outcome ) {
                            this.secondaryUserDialog = false
                            this.projectDetails.users = delete_secondary_user.data.users.filter( usr => usr.project_id == user.project_id)
                            this.$emit('refreshUsers', this.projectDetails.project_id, delete_secondary_user.data.message)
                        } else {
                            // console.log(delete_secondary_user.data.message);
                            this.$emit('refreshUsers', this.projectDetails.project_id, delete_secondary_user.data.message)
                        }
                    }
                } catch ( err ) {
                    console.log( err )
                }
            },

            formatDate: function ( date, mask ) {
                // return date != 0 ? dateFormat(new Date(date * 1000), mask) : 'No Expiration'
                return date != 0 ? dateFormat(new Date(date * 1000), mask) : false
            },
        }
}
</script>

<style scoped>
    .no_expiration {
        font-size: .75rem; 
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/ProjectUsers.vue